import React from 'react';
import PropTypes from 'prop-types';

import IntersectionObserver from '@components/IntersectionObserver';
import RenderGenericChildren from '@components/RenderGenericChildren';
import Observer from '@utils/browser/intersectionObserver';

class OnVisibleInViewport extends React.Component {
  intersectionCallback = entry => {
    const { entirelyVisible, onVisible } = this.props;
    const shouldCallOnVisible = entirelyVisible
      ? Observer.elementIsEntirelyVisible(entry)
      : Observer.elementIsVisible(entry);

    if (shouldCallOnVisible) onVisible();
  };

  render() {
    const { children, style, thresholdMargin } = this.props;

    return (
      <IntersectionObserver
        callback={this.intersectionCallback}
        style={style}
        thresholdMargin={thresholdMargin}
      >
        <RenderGenericChildren>{children}</RenderGenericChildren>
      </IntersectionObserver>
    );
  }
}

OnVisibleInViewport.propTypes = {
  entirelyVisible: PropTypes.bool,
  thresholdMargin: PropTypes.string,
  style: PropTypes.object,
  onVisible: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

OnVisibleInViewport.defaultProps = {
  entirelyVisible: true,
};

export default OnVisibleInViewport;
